import {
  ACTION_LOGIN,
  ACTION_LOGOUT,
  ACTION_FETCH_USER,
  ACTION_CLEAR_MESSAGES,
  ACTION_LOGIN_REQUEST,
  ACTION_LOGIN_FAILURE,
  ACTION_LOGOUT_REQUEST,
  ACTION_LOGOUT_FAILURE,
  ACTION_FETCH_USER_REQUEST,
  ACTION_FETCH_USER_FAILURE,
  ACTION_SSO_LOGIN,
} from '../../actions/api/account';

const KEY_ACCOUNT_TOKEN = 'account.token';

export const ACCOUNT_STATUS_READY = 'ready';
export const ACCOUNT_STATUS_FETCHING = 'fetching_user';
export const ACCOUNT_STATUS_UPDATING = 'updating_user';
export const ACCOUNT_STATUS_LOGIN = 'logging_in';
export const ACCOUNT_STATUS_LOGOUT = 'logging_out';
export const ACCOUNT_STATUS_REGISTRATION = 'registering';

function isTokenOutdated(token) {
  if (token != null) {
    let accessToken = token.access_token;
    if (accessToken != null) {
      let parts = accessToken.split('.');
      if (parts.length === 3) {
        let claims = JSON.parse(atob(parts[1]));
        if (claims.exp != null) {
          return Date.now() >= claims.exp * 1000;
        }
      }
    }
  }
  return false;
}

function getStoredToken() {
  try {
    let token = JSON.parse(localStorage.getItem(KEY_ACCOUNT_TOKEN));
    if (isTokenOutdated(token)) {
      localStorage.removeItem(KEY_ACCOUNT_TOKEN);
      return null;
    }
    return token;
  } catch (ignore) {
    return null;
  }
}

function storeToken(token) {
  try {
    if (token) {
      localStorage.setItem(KEY_ACCOUNT_TOKEN, JSON.stringify(token));
    } else {
      localStorage.removeItem(KEY_ACCOUNT_TOKEN);
    }
    return getStoredToken();
  } catch (ignore) {
    return null;
  }
}

const initialState = {
  user: null,
  token: getStoredToken(),
  status: ACCOUNT_STATUS_READY,
  messages: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case ACTION_FETCH_USER_REQUEST:
      return { ...state, status: ACCOUNT_STATUS_FETCHING };

    case ACTION_FETCH_USER:
      return { ...state, status: ACCOUNT_STATUS_READY, user: action.result };

    case ACTION_FETCH_USER_FAILURE:
      return {
        ...state,
        status: ACCOUNT_STATUS_READY,
        messages: action.silent ? [] : [action.message],
      };

    case ACTION_LOGIN_REQUEST:
      return { ...state, status: ACCOUNT_STATUS_LOGIN, messages: [] };

    case ACTION_LOGIN:
      storeToken(action.result);
      return {
        ...state,
        status: ACCOUNT_STATUS_READY,
        token: action.result,
        messages: [],
      };

    case ACTION_SSO_LOGIN:
      var token = {
        UserName: action.token.username,
        status: ACCOUNT_STATUS_READY,
        access_token: action.token.token,
        token_type: 'bearer',
      };
      storeToken(token);
      return {
        ...state,
        token: token,
      };
    case ACTION_LOGIN_FAILURE:
      return {
        ...state,
        status: ACCOUNT_STATUS_READY,
        messages: action.silent ? [] : [action.message],
      };

    case ACTION_LOGOUT_REQUEST:
      return { ...state, status: ACCOUNT_STATUS_LOGOUT, messages: [] };

    case ACTION_LOGOUT:
      storeToken(null);
      localStorage.clear();
      return {
        ...state,
        status: ACCOUNT_STATUS_READY,
        token: null,
        user: null,
      };

    case ACTION_LOGOUT_FAILURE:
      return {
        ...state,
        status: ACCOUNT_STATUS_READY,
        messages: [action.message],
      };

    case ACTION_CLEAR_MESSAGES:
      return { ...state, messages: [] };

    default:
      return state;
  }
};
